export default "__VITE_ASSET__DAEpJh1b__"